import { Box } from '@mantine/core';
import PlayerDrawing from '../components/PlayerDrawing';
import GameScreen from '../components/GameScreen';
import useViewportScale from '../hooks/useViewportScale';

function RoundResultsScreen({ votingResults, judgeAward, players, currentJudgeId, currentPrompt }) {
  const px = useViewportScale();
  const winner = votingResults.find(r => r.rank === 1);
  const others = votingResults.filter(r => r.rank !== 1);
  const winnerPlayer = winner && players.find(p => p.id === winner.playerId);

  return (
    <GameScreen
      backgroundImage="/waiting-bg1.png"
      title={winner ? `${winner.playerName} wins!` : 'Results'}
      subtitle={currentPrompt}
      contentPosition="top"
      introSound={"/Wow that my favorite doodle.m4a"}
      featuredPlayer={winnerPlayer}
      featuredPlayerSize={px(350)}
      featuredDrawing={winner?.response}
      featuredDrawingSize={px(350)}
      judgeAward={judgeAward}
      judgeAwardSize={px(120)}
      players={players}
    >
    </GameScreen>
  );
}

export default RoundResultsScreen;
